/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'factory-wage': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M32.347 9.958L32 9.83l-.347.128L.03 21.653l.694 1.876 1.737-.642V54.17H61.54V22.887l1.736.642.694-1.876L32.347 9.958zM4.88 27.233h3.044v5H4.88v-5zm6.957 0H8.793v5h3.044v-5zm2.5 0h3.043v5h-3.043v-5zm6.956 0H18.25v5h3.043v-5zm2.5 0h3.044v5h-3.044v-5zm6.957 0h-3.044v5h3.044v-5zm2.5 0h3.044v5H33.25v-5zm6.956 0h-3.043v5h3.044v-5zm2.5 0h3.044v5h-3.043v-5zm6.957 0H46.62v5h3.043v-5zm2.5 0h3.044v5h-3.044v-5zm6.957 0h-3.044v5h3.044v-5z" _fill="#EF7812"/>'
  }
})
